export default {
    filters: {
        formatNumber(n){
            //Insert a '.' for every third number for readability

            //TODO: Refactor to more performant solution
            n = n.toString();

            if(n.length < 4){
                return n;
            }
            
            return n.split('')
                .reverse()
                .join('')
                .match(/\d{1,3}/g)
                .map(x => x.split('').reverse().join(''))
                .reverse()
                .join('.');
        }
    }
}